import React, {Component} from 'react';
import MultipleDatePicker from 'react-multiple-datepicker';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Tabs, Tab} from 'material-ui/Tabs';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Badge from 'material-ui/Badge';
import moment from "moment";
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import ReactHtmlTableToExcel from "react-html-table-to-excel";


import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';
import TableDataView from "../tables/TableDataView";
import {isSupperAdminUser} from "../../api/others";

class CompDashboardAccountSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            organisation: "",
            accountRef: "",
            username: "",
            Data: null,
            DataCustomers: [],
            Wallets: [],
            Dealers: [],
            Agents: [],
            selectRow: null,

            startDate: new Date(),
            endDate: new Date(),
            rate: "",
            amountFrom: "",
            selectedDealer: "",
            selectedData: [],
            showDetail: false,
            viewData: [],
            filterDetail: "",
        }

    }

    async componentWillMount() {
        await isSupperAdminUser();
        const user = GetUserToken();
        this.setState({organisation: user.OrgCode, username: user.Username});
    }

    async componentDidMount() {
        await this.fetchDealer();
        await this.fetchAgents();
    }

    handleChangeStartDate = (date) => {
        this.setState({
            startDate: date
        });
    }
    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date
        });
    }
    handleChangeType = (e) => {
        let tmp = this.state;
        tmp["selectedDealer"] = e.target.value;
        this.setState(tmp);
    }
    handleChange = (e) => {
        let key=e.target.name;
        let val=e.target.value;
        let tmp = this.state;
        tmp[key] = val;
        this.setState(tmp);
    }
    convertDateFormat_YYYYMMDD = (datesIn) => {
        let myDate = moment(datesIn).format("YYYY-MM-DD");
        return myDate;
    }

    fetchDealer = async () => {
        let _this = this;
        let conds = [];

        this.fetchingAll("Dealership", conds, (data) => {
            console.log("fetchDealer :> ", data);
            let accountRef = _this.state.accountRef;
            const username = _this.state.username;
            for (let i in data) {
                const row = data[i];
                if (row.email === username) {
                    accountRef = row.ref;
                }
            }
            _this.setState({
                Dealers: data,
                accountRef: accountRef
            });
        });
    }

    fetchAgents = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("agent", conds, (data) => {
            console.log("fetchAgents :> ", data);
            let accountRef = _this.state.accountRef;
            const username = _this.state.username;
            for (let i in data) {
                const row = data[i];
                if (row.email === username) {
                    accountRef = row.ref;
                }
            }
            _this.setState({
                Agents: data,
                accountRef: accountRef
            });
        });
    }

    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }

    submitSearchDashboardSummary = async () => {
        let state = this.state;
        let _this = this;

        if (state.selectedType === "") {
            alert("Please select your report type!");
            return
        }

        /*
        hub.StartDate = "2020-06-01"
        hub.EndDate = "2020-06-30"
        hub.AmountFrom = 21
        hub.DealerRef = "0815520489"
        hub.RateByItem = 30
         */

        let hub = {
            DealerRef: state.selectedDealer,
            StartDate: this.convertDateFormat_YYYYMMDD(state.startDate),
            EndDate: this.convertDateFormat_YYYYMMDD(state.endDate),
            AmountFrom: parseFloat(state.amountFrom),
            RateByItem: parseFloat(state.rate),
        };


        console.log("Submit submitSearchDashboardSummary > ", hub);

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/dashboard/summary";


        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("Submit submitSearchDashboardSummary response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const res = dataIn.RESULT;
                let tmp = _this.state;
                tmp.Data = res.Result;
                tmp.DataCustomers = res.Customers;
                _this.setState(tmp);
                //TODO reinitialize state
            }
        });

    }

    getValue = (key) => {
        if (typeof this.state[key] !== "undefined") {
            return this.state[key]
        }
        return "";
    }

    renderSummaryTab = () => {
        let ls = [];
        let o=
            {
                DealerRef   :(<span style={{fontWeight:"bold"}}>TOTAL</span>),
                DealerName  :"",
                AgentRef    :"",
                AgentName   :"",
                TotalSale   :0,
                TotalAmount :0,
                Rate        :"",
            };
        let totalSale=0,totalCost=0,totalCommission=0;
        for (let i in this.state.Data) {
            const row = this.state.Data[i];
            ls.push(row);
            totalSale +=row. TotalSale;
            totalCommission +=row. TotalAmount;
            totalCost +=row.Cost;
        }
        o.TotalSale=(<span style={{fontWeight:"bold",color:"red"}}>{totalSale}</span>);
        o.TotalAmount=(<span style={{fontWeight:"bold",color:"red"}}>{totalCommission}</span>);
        o.Cost=(<span style={{fontWeight:"bold",color:"red"}}>{totalCost}</span>);
        ls.push(o);
        return (
            <div>
                <h2>Summary report</h2>
                <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="download-table-xls-button pull-right"
                    table="tbDetail01"
                    filename="tablexls"
                    sheet="tablexls"
                    buttonText="Download as XLS"

                />
                <table className={"table"}  id={"tbDetail01"}>
                    <thead>
                    <tr>
                        <th>Agent</th>
                        <th>Contact Number</th>
                        <th>Sales</th>
                        <th>Amount(Rand)</th>
                        <th>Rate</th>
                        <th>Commission</th>
                    </tr>
                    </thead>
                    <tbody>
                    {ls.map((row) => {
                        return (
                            <tr>
                                <td>{row.AgentName}</td>
                                <td>{row.AgentRef}</td>
                                <td>{row.TotalSale}</td>
                                <td>{row.Cost}</td>
                                <td>{row.Rate}</td>
                                <td>{row.TotalAmount}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        )
    }
    renderCustomerTab = () => {
        let ls = [];
        for (let i in this.state.DataCustomers) {
            const number = this.state.DataCustomers[i];
            ls.push({
                Msisdn: number
            })
        }
        let columns = [
            {id: 'Msisdn', label: 'Msisdn', minWidth: 170, dataType: "string"},
        ]

        let data = {columns: columns, data: ls};
        let opts={
            pageSize:100,
        }
        return (
            <div>
                <h2>Customer MSISDN list</h2>

                <TableDataView
                    {...data}
                    tableTitle={"MSISDN list"}
                    options={opts}

                />

            </div>
        )
    }

    render() {
        console.log("Dealers --> ", this.state.Dealers);
        const user = GetUserToken();
        let ls=[];
        for(let i in this.state.Dealers){
            let row=this.state.Dealers[i];
            if(user.Role==="dealer"){
                //console.log("(:)---> ",row,"=",user.Username,">",row.Ref===user.Username)
                if(row.email===user.Username){
                    ls.push(row)
                }
            }else{
                ls.push(row)
            }
        }
        return (


            <PageContentWallpaper {...this.props} >
                <MuiThemeProvider>

                    <div className="row">
                        <div className="col-xs-12">
                            <h2>Dashboard Account Summary Report</h2>
                            <small>Your account: {this.state.accountRef}</small>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-row">
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState">Start Date</label>
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={this.handleChangeStartDate}
                                        className="form-control"
                                    />
                                </div>

                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState">End Date</label>
                                    <DatePicker
                                        selected={this.state.endDate}
                                        onChange={this.handleChangeEndDate}
                                        className="form-control"
                                    />

                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState">Amount</label>
                                    <input
                                        className="form-control"
                                        name={"amountFrom"}
                                        value={this.state.amountFrom}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState">Rate</label>
                                    <input
                                        className="form-control"
                                        name={"rate"}
                                        value={this.state.rate}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>

                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState">Dealer</label>
                                    <select
                                        onChange={(e) => this.handleChangeType(e)}
                                        className="form-control"
                                        value={this.getValue("selectedDealer")}
                                    >
                                        <option value={""}>--Select your Dealer--</option>
                                        {ls.map((row) => {
                                            return (
                                                <option value={row.ref}>{row.name}</option>
                                            )
                                        })}
                                    </select>

                                </div>


                                <div className="form-group col-md-2">
                                    <label htmlFor="inputState">&nbsp;</label>
                                    <button
                                        className="form-control pull-right btn btn-default"
                                        onClick={() => this.submitSearchDashboardSummary()}
                                    >Search
                                    </button>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">

                            <Tabs>
                                <Tab label="Summary">
                                    {this.renderSummaryTab()}
                                </Tab>
                                <Tab label="MSISDN">
                                    {this.renderCustomerTab()}
                                </Tab>


                            </Tabs>

                        </div>


                    </div>

                </MuiThemeProvider>
            </PageContentWallpaper>
        )
    }


}


const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompDashboardAccountSummary)
